import {
  HASH_LOADING,
  HASH_SUCCESS,
  HASH_ERROR,
  HASH_LOGOUT,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";
import hashInitialState from "../initialStates/hashInitialState";

const hash = (state, { payload, type }) => {
  switch (type) {
    case HASH_LOADING:
      return {
        ...state,
        hash: {
          ...state.hash,
          error: false,
          loading: true,
        },
      };
    case HASH_SUCCESS:
      return {
        ...state,
        hash: {
          ...state.hash,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case HASH_ERROR:
      return {
        ...state,
        hash: {
          ...state.hash,
          error: payload,
          loading: false,
        },
      };
    case HASH_LOGOUT:
      return hashInitialState;
    case RESET_PORTAL_CONTEXT:
      return hashInitialState;

    default:
      return state;
  }
};

export default hash;
